<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetZusaetzlicheAngaben"></a>
      <h3>
        <i class="icon-reisedaten"></i> <span i18n>Zusätzliche Angaben</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">


          <div class="card" [formGroup]="form">

            <div class="float-start card-header card-header-detail" i18n>Zusätzliche Angaben</div>

            <div class="card-body">

              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.abweichendeSchreibweiseName" i18n
                           [class.mandatory]="isMandatory('abweichendeSchreibweiseName')">
                      Abweichende Schreibweise Antragsteller:</label>
                    <input id="antragsteller.personendaten.abweichendeSchreibweiseName"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('abweichendeSchreibweiseName')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['abweichendeSchreibweiseName'])"
                           formControlName="abweichendeSchreibweiseName">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.befoerderungsmittel"
                           [class.mandatory]="isMandatory('befoerderungsmittel')"
                           i18n>Beförderungsmittel:</label>
                    <select id="reisedaten.befoerderungsmittel"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['befoerderungsmittel'])"
                            formControlName="befoerderungsmittel">
                      <option value=""></option>
                      <option *ngFor="let listItem of befoerderungsmittelListItems"
                              value="{{ listItem.key }}">{{ listItem.value }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
                  <app-stickernummer formControlName="stickernummer"></app-stickernummer>
                </div>

              </div>

              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <span i18n>Haben Sie für Ihren Aufenthalt eine Reisekrankenversicherung?</span>
                    <div class="form-check">
                      <input id="reisedaten.reisekrankenversicherung.vorhanden"
                             class="form-check-input" type="checkbox"
                             formControlName="rkvJaNein">
                      <label for="reisedaten.reisekrankenversicherung.vorhanden" i18n>ja</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-4" *ngIf="form.value.rkvJaNein === true">
                  <div class="mb-3">
                    <label for="reisedaten.reisekrankenversicherung.daten.gesellschaft" i18n [class.mandatory]="isMandatory('rkvAnbieter')"
                    >Anbieter der Reisekrankenversicherung:</label>
                    <input id="reisedaten.reisekrankenversicherung.daten.gesellschaft"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('rkvAnbieter')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['rkvAnbieter'])"
                           formControlName="rkvAnbieter">
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <span i18n>Abholer?</span>
                    <div class="form-check">
                      <input id="sonstiges.abholer"
                             class="form-check-input" type="checkbox"
                             formControlName="abholer">
                      <label for="sonstiges.abholer" i18n>ja</label>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" *ngIf="form.value.abholer === true">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="sonstiges.vorname" i18n [class.mandatory]="isMandatory('vorname')">Vorname(n):</label>
                    <input id="sonstiges.vorname"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('vorname')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['vorname'])"
                           formControlName="vorname">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="sonstiges.familienname" i18n [class.mandatory]="isMandatory('vorname')">Familienname:</label>
                    <input id="sonstiges.familienname"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('familienname')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['familienname'])"
                           formControlName="familienname">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="sonstiges.anschrift" i18n [class.mandatory]="isMandatory('anschrift')">Anschrift:</label>
                    <input id="sonstiges.anschrift"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('anschrift')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschrift'])"
                           formControlName="anschrift">
                  </div>
                </div>

              </div>

              <div class="row"
                   *ngIf="this.form.controls.foermlicheVerpflichtungserklaerungDatum.enabled && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="referenz.foermlicheVerpflichtungserklaerung.datum"
                           [class.mandatory]="isMandatory('foermlicheVerpflichtungserklaerungDatum')"
                           i18n>Förmliche Verpflichtungserklärung - Datum (TT.MM.JJJJ):</label>
                    <div class="input-group">
                      <input angular-mydatepicker
                             id="referenz.foermlicheVerpflichtungserklaerung.datum"
                             #foermlicheVerpflichtungserklaerungDatum="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['foermlicheVerpflichtungserklaerungDatum'])"
                             [attr.maxlength]="getMaxLength('foermlicheVerpflichtungserklaerungDatum')"
                             formControlName="foermlicheVerpflichtungserklaerungDatum"
                             (inputFieldChanged)="onDatePickerInputFieldChanged('foermlicheVerpflichtungserklaerungDatum', $event)"
                             (blur)="onDatePickerBlur('foermlicheVerpflichtungserklaerungDatum')">
                      <span class="input-group-text date-picker"
                            (click)="foermlicheVerpflichtungserklaerungDatum.toggleCalendar()"
                      ><i class="icon-calendar"></i></span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row"
                   *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT' && this.form.controls.begruedungFuerFehlendeReferenz.enabled">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="referenz.begruedungFuerFehlendeReferenz"
                           [class.mandatory]="isMandatory('begruedungFuerFehlendeReferenz')"
                           i18n>Begründung, warum "Keine Referenzperson" ausgewählt ist:</label>
                    <select id="referenz.begruedungFuerFehlendeReferenz"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['begruedungFuerFehlendeReferenz'])"
                            formControlName="begruedungFuerFehlendeReferenz">
                      <option value=""></option>
                      <option *ngFor="let listItem of begruedungFuerFehlendeReferenzListItems"
                              value="{{ listItem.key }}">{{ listItem.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <label i18n for="zusatzangaben.weitereAngaben">Zusätzliche Informationen für die Auslandsvertretung/Konsulat:</label>
                  <textarea
                    id="zusatzangaben.weitereAngaben"
                    rows="3"
                    appToUpperCase
                    [attr.maxlength]="getMaxLength('weitereAngaben')"
                    class="form-control form-control-sm"
                    [class.is-invalid]="errorClassRequired(form.controls['weitereAngaben'])"
                    formControlName="weitereAngaben"
                  ></textarea>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
